import { ApiService } from '@shared/services';
import { IAccountSettingsService } from '@orgs/interfaces/services';
import { AccountSettingsModel } from '@orgs/models/AccountSettings';

export class AccountSettingsService extends ApiService implements IAccountSettingsService {
    constructor() {
        super('/accountSetting');
    }

    getAccountSettings(role: string): Promise<AccountSettingsModel> {
        return this.get(`/${role === 'OrganizationAdministrator' ? 'organization' : role}/get`);
    }

    updateAccountSettings(role: string, params: AccountSettingsModel):
        Promise<AccountSettingsModel> {
        return this.put(`/${role === 'OrganizationAdministrator' ? 'organization' : role}/update`, params);
    }
}
